import Vue from "vue";
import Router from "vue-router";
import Dashboard from "@/components/dashboard/Dashboard";
import Component from "@/components/product/Component";
import Login from "@/components/login/Login";
import Catalog from "@/components/catalog/Catalog";
import Orders from "@/components/orders/Orders";
import Error from "@/components/error/Error";
import Plano from "@/components/plano/Plano";
import Cluster from "@/components/plano/config/Cluster";
import ParamMeuble from "@/components/plano/ParamMeuble";
import CampaignList from "@/components/campaign/CampaignList";
import ExportExcel from "@/components/export/ExportExcel";
import Campaign from "@/components/campaign/Campaign";
import Template from "@/components/plano/templatePlano";
import Planos from "@/components/planos/Planos";
import Configurator from "@/components/configurator/Configurator";
import ProductImgEditor from "@/components/configurator/ImgEditor";
import FasciaConfig from "@/catalog/fascia-editor";
import BlankingGraphicConfig from "@/catalog/blanking-graphic-editor";
import DivderConfig from "@/catalog/divider-editor";
import FrameConfig from "@/catalog/frame-editor";
import ShelfConfig from "@/catalog/shelf-editor";
import CaddyConfig from "@/catalog/caddy-editor";
import EditComponent from "@/components/component-form/edit-component";
import CreateComponent from "@/components/component-form/create-component";
import LadderConfig from "@/catalog/ladder-config";
import Displayers from "@/components/displayers/Displayers";
import Uploader from "@/components/uploader/uploader";
import StandDesignList from "@/components/standDesign/standList";
import ZoneList from "@/components/admin/zone/ZoneList";
import UserRole from "@/components/admin/user/UserRole";
import UserList from "@/components/users/UserList";
import CreateZone from "@/components/admin/zone/CreateZone";
import BrandList from "@/components/admin/brand/BrandList";
import VersioningList from "@/components/admin/versioning/VersioningList";
import Versionings from "@/components/versioning/Versionings";
import ComponentList from "@/components/componentType/ComponentList";
import AdminTools from "@/components/adminTools/Admin";
import EditDisplayer from "@/components/displayers/EditDisplayer";
import InactiveComponent from "@/components/admin/InactiveComponent";
import BrandAdminList from "@/components/admin/brand/BrandAdminList";
import Categories from "@/components/admin/categories/Categories";
import AccessUser from "../plugins/AccessUser";
import Basket from "@/components/basket/Basket";
import MyOrder from "@/components/orders/myOrder";
import ListOrders from "@/components/eStore/ListOrders";
import OrderDetail from "@/components/eStore/OrderDetail";
import CreateCountDown from "@/components/admin/countdown/CreateCountDown";
import Carcass from "@/components/plano/config/carcass/carcass";
import Element from "@/components/Element";
import SearchAllComponents from "@/components/search/SearchAllComponents";
import Shades from "@/components/shades/Shades";
import SummaryOrderWindow from "../components/orders/SummaryOrderWindow";
import App from "@/App";
import PlanoNext from "@/plano/editor";
import TemplateEditor from "@/plano/template";
import { clearLocalStorage } from "@/utils/storage";
import SsoSystemList from "@/components/admin/sso-system/SsoSystemList";
import Properties from "@/components/admin/properties/Properties";
import cacheService from "@/services/cache";
import { router as forecastRouter } from "@/components/forecasts/router";
import { router as catalogForecastRouter } from "@/components/catalogForcast/router";
import currentBrand from "@/services/currentBrand";
import brandService from "@/services/brand";
import Profiles from "@/components/admin/profiles/Profiles";
import ProfileRole from "@/components/admin/profiles/ProfileRole";
import Zones from "@/components/admin/zone/Zones";
import CreateUser from "@/components/users/actions/CreateUser";
import ZoneRole from "@/components/admin/zone/ZoneRole";
import { APPLICATION } from "@/components/admin/brand/constant";
import { PROFILES } from "@/plugins/constant";
import ZoneGroups from "@/components/admin/zoneGroups/ZoneGroups";
import Logs from "../components/admin/logs/Logs";
import Help from "@/components/help/Help";

export const ERROR_PAGE_NAME = "error404";

Vue.use(Router);

const routes = [
    {
        path: "/planonext/:planoId",
        component: PlanoNext,
        meta: {
            requiresAuth: true,
            title: "Rem3rch Page Planogram",
            functionality: "plano_builder"
        }
    },
    {
        path: "/admin/components/new",
        component: CreateComponent,
        meta: {
            requiresAuth: true,
            title: "Create Component"
        }
    },
    {
        path: "/components/:id/edit",
        component: EditComponent,
        meta: {
            requiresAuth: true,
            title: "Edit Component"
        }
    },
    {
        path: "/templates/new",
        component: TemplateEditor,
        meta: {
            requiresAuth: true,
            title: "Create Template",
            functionality: "plano_builder"
        }
    },
    {
        path: "/templates/:id",
        component: TemplateEditor,
        meta: {
            requiresAuth: true,
            title: "Edit Template",
            functionality: "plano_builder"
        }
    },
    // adding a route that matches /COMPONENT_TYPE/:id/editor
    // automatically adds a `configurator` button on `/COMPONENT_TYPE/:id
    {
        path: "/ladder/:id/editor",
        component: LadderConfig,
        name: "LadderConfig",
        meta: {
            requiresAuth: true,
            title: "Rem3rch Page Ladder Editor"
        }
    },
    {
        path: "/caddy/:id/editor",
        component: CaddyConfig,
        name: "CaddyConfig",
        meta: {
            requiresAuth: true,
            title: "Rem3rch Page Caddy Editor"
        }
    },
    {
        path: "/shelf/:id/editor",
        component: ShelfConfig,
        name: "ShelfConfig",
        meta: {
            requiresAuth: true,
            title: "Rem3rch Page Shelf Editor"
        }
    },
    {
        path: "/fascia/:id/editor",
        component: FasciaConfig,
        name: "FasciaConfig",
        meta: {
            requiresAuth: true,
            title: "Rem3rch Page Fascia Editor"
        }
    },
    {
        path: "/blanking_graphic/:id/editor",
        component: BlankingGraphicConfig,
        name: "BlankingGraphicConfig",
        meta: {
            requiresAuth: true,
            title: "Rem3rch Page Blanking Graphic Editor"
        }
    },
    {
        path: "/ticket_strip/:id/editor",
        component: DivderConfig,
        name: "TicketStripConfig",
        meta: {
            requiresAuth: true,
            title: "Rem3rch Page Ticket Strip Editor"
        }
    },
    {
        path: "/divider/:id/editor",
        component: DivderConfig,
        name: "DividerConfig",
        meta: {
            requiresAuth: true,
            title: "Rem3rch Page Divider Editor"
        }
    },
    {
        path: "/frame/:id/editor",
        component: FrameConfig,
        name: "FrameConfig",
        meta: {
            requiresAuth: true,
            title: "Rem3rch Page Frame Editor"
        }
    },
    {
        path: "",
        component: App,
        children: [
            {
                path: "/login",
                component: Login,
                name: "Login",
                beforeEnter: (to, from, next) => {
                    clearLocalStorage();
                    return next();
                }
            },
            {
                path: "/error403",
                component: Error,
                props: { codeError: "403" },
                name: "error403",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Error 403"
                }
            },
            {
                path: "/",
                component: Dashboard,
                name: "Dashboard",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Home Page",
                    metaTags: [
                        {
                            name: "description",
                            content: "The about page of our example app."
                        },
                        {
                            property: "og:description",
                            content: "The about page of our example app."
                        }
                    ]
                }
            },
            {
                path: "/product/:id",
                component: Component,
                name: "Product",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Produit"
                }
            },
            {
                path: "/element",
                component: Element,
                name: "Element",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Element"
                }
            },
            {
                path: "/product/:id/imgEditor",
                component: ProductImgEditor,
                name: "ProductImgEditor",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Img Editor"
                }
            },
            {
                path: "/module/:id",
                component: Component,
                name: "Module",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Module"
                }
            },
            {
                path: "/structure/:id",
                component: Component,
                name: "Structure",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Structure"
                }
            },
            {
                path: "/fascia/:id",
                component: Component,
                name: "Fascia",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Fascia"
                }
            },
            {
                path: "/blanking_graphic/:id",
                component: Component,
                name: "BlankingGraphic",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page BlankingGraphic"
                }
            },
            {
                path: "/ladder/:id",
                component: Component,
                name: "Ladder",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Ladder"
                }
            },
            {
                path: "/caddy/:id",
                component: Component,
                name: "Caddy",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Caddy"
                }
            },
            {
                path: "/divider/:id",
                component: Component,
                name: "Divider",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Divider"
                }
            },
            {
                path: "/shelf/:id",
                component: Component,
                name: "Shelf",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Shelf"
                }
            },
            {
                path: "/ticket_strip/:id",
                component: Component,
                name: "Ticket Strip",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Ticket Strip"
                }
            },
            {
                path: "/display/:id",
                component: Component,
                name: "Display",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Display"
                }
            },
            {
                path: "/frame/:id",
                component: Component,
                name: "Frame",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Frame"
                }
            },
            {
                path: "/orders",
                component: Orders,
                name: "Orders",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Orders"
                }
            },
            {
                path: "/catalog",
                component: Catalog,
                name: "Catalog",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Catalog"
                }
            },
            {
                path: "/shades",
                component: Shades,
                name: "Shades",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Shades"
                }
            },
            {
                path: "/all-components",
                component: SearchAllComponents,
                name: "SearchAllComponents",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Search all components"
                }
            },
            {
                path: "/list-orders",
                component: ListOrders,
                name: "ListOrders",
                meta: {
                    requiresAuth: true,
                    title: "List orders"
                }
            },
            {
                path: "/list-orders/detail/:id",
                component: OrderDetail,
                name: "OrderDetail",
                meta: {
                    requiresAuth: true,
                    title: "Order detail"
                }
            },
            {
                path: "/artwork/:id",
                component: Component,
                name: "Artwork",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Artwork"
                }
            },
            {
                path: "/peel-off/:id",
                component: Component,
                name: "Peel-off",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Peel-off"
                }
            },
            {
                path: "/accessory/:id",
                component: Component,
                name: "Accessory",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Accessoire"
                }
            },
            {
                path: "/plano/:id",
                component: Plano,
                name: "Plano",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Planogram",
                    functionality: "plano_builder"
                }
            },

            {
                path: "/plano/config/carcass",
                component: Carcass,
                name: "Carcass",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Configuation carcass",
                    functionality: "plano_builder"
                }
            },
            {
                path: "/plano/config/carcass/:id",
                component: Carcass,
                name: "Carcass-edit",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Configuation carcass edit",
                    functionality: "plano_builder"
                }
            },
            {
                path: "/plano/config/cluster/:id",
                component: Cluster,
                name: "Cluster",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Configuation cluster",
                    functionality: "plano_builder"
                }
            },
            {
                path: "/campaigns/campaign-list",
                component: CampaignList,
                name: "CampaignList",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Campaign",
                    action: AccessUser.ACTION.UPDATE,
                    apps: [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID],
                    profiles: [PROFILES.FORECAST_MANAGER, PROFILES.ZONES_SUPERVISOR, PROFILES.COORDINATOR],
                    functionality: ["campaign_manager", AccessUser.CLIENT_ADMIN, AccessUser.SUPPER_ADMIN]
                }
            },
            {
                path: "/exportExcel",
                component: ExportExcel,
                name: "ExportExcel",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Archive Export",
                    action: AccessUser.ACTION.UPDATE
                }
            },
            {
                path: "/admin-tools",
                component: AdminTools,
                name: "AdminTools",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page AdminTools",
                    functionality: AccessUser.SUPPER_ADMIN
                }
            },
            {
                path: "/campaigns/create",
                component: Campaign,
                name: "Campaign",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Campaign"
                }
            },
            {
                path: "/admin-tools/categories",
                component: Categories,
                name: "Categories",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Categories"
                }
            },
            {
                path: "/admin-tools/components",
                component: InactiveComponent,
                name: "InactiveComponent",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page InactiveComponent"
                }
            },
            {
                path: "/edit-displayer",
                component: EditDisplayer,
                name: "EditDisplayer",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page EditDisplayer"
                }
            },
            {
                path: "/zones/create",
                component: CreateZone,
                name: "CreateZone",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page CreateZone",
                    action: AccessUser.ACTION.VALIDATE,
                    apps: [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID],
                    profiles: [PROFILES.FORECAST_MANAGER],
                    functionality: ["user_manager", AccessUser.CLIENT_ADMIN, AccessUser.SUPPER_ADMIN]
                }
            },
            {
                path: "/standDesign-list",
                component: StandDesignList,
                name: "StandDesignList",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page StandDesignList"
                }
            },
            {
                path: "/componentType-list",
                component: ComponentList,
                name: "ComponentList",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page ComponentList"
                }
            },
            {
                path: "/zones/zone-list",
                component: ZoneList,
                name: "ZoneList",
                meta: {
                    requiresAuth: true,
                    title: "Tools - Manage Zones",
                    action: AccessUser.ACTION.UPDATE,
                    apps: [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID],
                    profiles: [PROFILES.FORECAST_MANAGER, PROFILES.ZONES_SUPERVISOR, PROFILES.COORDINATOR],
                    functionality: ["zone_manager", AccessUser.CLIENT_ADMIN, AccessUser.SUPPER_ADMIN]
                }
            },
            {
                path: "/zones/zone/:id",
                component: ZoneRole,
                name: "ZoneRole",
                meta: {
                    requiresAuth: true,
                    title: "Tools - Manage Zones info + zone",
                    action: AccessUser.ACTION.UPDATE,
                    apps: [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID],
                    profiles: [PROFILES.FORECAST_MANAGER, PROFILES.ZONES_SUPERVISOR, PROFILES.COORDINATOR],
                    functionality: ["zone_manager", AccessUser.CLIENT_ADMIN, AccessUser.SUPPER_ADMIN]
                }
            },
            {
                path: "/admin/zones",
                component: Zones,
                name: "Zones",
                meta: {
                    requiresAuth: true,
                    title: "Admin - Zone access",
                    functionality: AccessUser.SUPPER_ADMIN
                }
            },
            {
                path: "/zones/groups/manage",
                component: ZoneGroups,
                name: "ZoneGroups",
                meta: {
                    requiresAuth: true,
                    title: "Tools - Manage Zone Groups",
                    action: AccessUser.ACTION.UPDATE,
                    apps: [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID],
                    profiles: [PROFILES.FORECAST_MANAGER, PROFILES.ZONES_SUPERVISOR, PROFILES.COORDINATOR],
                    functionality: ["zone_manager", AccessUser.CLIENT_ADMIN, AccessUser.SUPPER_ADMIN]
                }
            },
            {
                path: "/brand-list",
                component: BrandList,
                name: "BrandList",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page BrandList",
                    functionality: AccessUser.SUPPER_ADMIN
                }
            },
            {
                path: "/template-plano",
                component: Template,
                name: "Template",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Template Planogram"
                }
            },
            {
                path: "/displayers",
                component: Displayers,
                name: "Displayers",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page lite Meubles"
                }
            },
            {
                path: "/param_meuble",
                component: ParamMeuble,
                name: "ParamMeuble",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Param Meuble"
                }
            },
            {
                path: "/planos",
                component: Planos,
                name: "Planos",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Liste planograms",
                    functionality: "plano_builder"
                }
            },
            {
                path: "/configurator/:id",
                component: Configurator,
                name: "Configurator",
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Configurator"
                }
            },
            {
                path: "/admin/countdowns-list",
                component: CreateCountDown,
                name: "CountDowns",
                meta: {
                    requiresAuth: true,
                    title: "Create order window"
                }
            },
            {
                path: "/admin/uploader",
                component: Uploader,
                name: "Admin - Upload file",
                meta: {
                    requiresAuth: true,
                    title: "Admin - Upload file"
                }
            },
            {
                path: "/users/user/:id",
                component: UserRole,
                name: "useraccess",
                props: true,
                meta: {
                    requiresAuth: true,
                    title: "Admin - User access",
                    action: AccessUser.ACTION.UPDATE,
                    apps: [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID],
                    profiles: [PROFILES.FORECAST_MANAGER, PROFILES.ZONES_SUPERVISOR, PROFILES.COORDINATOR],
                    functionality: ["user_manager", AccessUser.CLIENT_ADMIN, AccessUser.SUPPER_ADMIN]
                }
            },
            {
                path: "/users/user-list",
                component: UserList,
                name: "userList",
                meta: {
                    requiresAuth: true,
                    title: "Admin - Users access",
                    action: AccessUser.ACTION.UPDATE,
                    apps: [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID],
                    profiles: [PROFILES.FORECAST_MANAGER, PROFILES.ZONES_SUPERVISOR, PROFILES.COORDINATOR],
                    functionality: ["user_manager", AccessUser.SUPPER_ADMIN, AccessUser.CLIENT_ADMIN]
                }
            },
            {
                path: "/users/create",
                component: CreateUser,
                name: "createUser",
                meta: {
                    requiresAuth: true,
                    title: "Admin - Users access",
                    action: AccessUser.ACTION.VALIDATE,
                    apps: [APPLICATION.FORECAST_ID, APPLICATION.CATALOG_FORECAST_ID],
                    profiles: [PROFILES.FORECAST_MANAGER, PROFILES.ZONES_SUPERVISOR, PROFILES.COORDINATOR],
                    functionality: ["user_manager", AccessUser.CLIENT_ADMIN, AccessUser.SUPPER_ADMIN]
                }
            },
            {
                path: "/admin/versionings",
                component: VersioningList,
                name: "versioninglist",
                meta: {
                    requiresAuth: true,
                    title: "Admin - Versionings",
                    functionality: AccessUser.SUPPER_ADMIN
                }
            },
            {
                path: "/summary-order-window/:id",
                component: {
                    template: '<router-view :key="$route.params.id"></router-view>'
                },
                children: [
                    {
                        path: "",
                        component: SummaryOrderWindow,
                        name: "summaryOrderWindow",
                        meta: {
                            title: "Summary Order Window"
                        }
                    }
                ],
                meta: {
                    requiresAuth: true,
                    title: "Summary Order Window",
                    functionality: AccessUser.SUPPER_ADMIN
                }
            },
            {
                path: "/basket/basket-list-items/:id",
                component: {
                    template: '<router-view :key="$route.params.id"></router-view>'
                },
                children: [
                    {
                        path: "",
                        component: Basket,
                        name: "BasketCmpt",
                        meta: {
                            title: "BasketCmpt"
                        }
                    }
                ],
                meta: {
                    requiresAuth: true,
                    title: "Basket",
                    functionality: AccessUser.SUPPER_ADMIN
                }
            },
            {
                path: "/my-order/:id",
                component: MyOrder,
                name: "MyOrder",
                meta: {
                    requiresAuth: true,
                    title: "Order"
                }
            },
            {
                path: "/versionings",
                component: Versionings,
                name: "versionings",
                meta: {
                    requiresAuth: true,
                    title: "Versionings"
                }
            },
            {
                path: "/admin/brands",
                component: BrandAdminList,
                name: "adminbrandlist",
                meta: {
                    requiresAuth: true,
                    title: "Admin - Brand Access",
                    functionality: AccessUser.SUPPER_ADMIN
                }
            },
            {
                path: "/admin/sso-system-list",
                component: SsoSystemList,
                name: "SsoSystemList",
                meta: {
                    requiresAuth: true,
                    title: "Admin - SSO Systems",
                    functionality: AccessUser.SUPPER_ADMIN
                }
            },
            {
                path: "/admin/properties",
                component: Properties,
                name: "Properties",
                meta: {
                    requiresAuth: true,
                    title: "Admin - Properties",
                    functionality: AccessUser.SUPPER_ADMIN
                }
            },
            {
                path: "/admin/profiles",
                component: Profiles,
                name: "Profiles",
                meta: {
                    requiresAuth: true,
                    title: "Admin - Profiles",
                    functionality: AccessUser.SUPPER_ADMIN
                }
            },
            {
                path: "/admin/profiles/:id",
                component: ProfileRole,
                name: "ProfileRole",
                meta: {
                    requiresAuth: true,
                    title: "Profile Role",
                    functionality: AccessUser.SUPPER_ADMIN
                }
            },
            {
                path: "/admin/link-logs",
                component: Logs,
                name: "Links Logs",
                meta: {
                    requiresAuth: true,
                    title: "Admin - Logs Import / Export",
                    functionality: AccessUser.SUPPER_ADMIN
                }
            },
            {
                path: "/help",
                component: Help,
                name: "Help page",
                meta: {
                    requiresAuth: true,
                    title: "Help"
                }
            },
            ...forecastRouter,
            ...catalogForecastRouter,
            {
                path: "*",
                component: Error,
                props: { codeError: "404" },
                name: ERROR_PAGE_NAME,
                meta: {
                    requiresAuth: true,
                    title: "Rem3rch Page Error 404"
                }
            }
        ]
    }
];

const router = new Router({
    mode: "history",
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    }
});

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
        let error = 0;
        const authUser = cacheService.getRem3rchUser();
        if (authUser) {
            if (to.query.brand || to.query.zone) {
                handleBrandAndZoneQueryParameters(to, from, next);
            }
            if (to.path === "/") {
                next();
            } else {
                const action = to.meta.action ? to.meta.action : AccessUser.ACTION.READ;
                const profiles = to.meta.profiles ? to.meta.profiles : null;
                const appsId = to.meta.apps ? to.meta.apps : [APPLICATION.FORECAST_ID];
                Vue.accessUser.init().then(accesses => {
                    if (to.meta.functionality) {
                        let access = accesses[0];
                        to.meta.functionality = Array.isArray(to.meta.functionality) ? to.meta.functionality : [to.meta.functionality];
                        to.meta.functionality.forEach(f => {
                            if (f === AccessUser.SUPPER_ADMIN) {
                                if (access.isSuperAdmin()) {
                                    next();
                                } else {
                                    error++;
                                }
                            } else if (f === AccessUser.DIAM_ADMIN) {
                                if (access.isSuperAdmin()) {
                                    next();
                                } else {
                                    error++;
                                }
                            } else if (f === AccessUser.CLIENT_ADMIN) {
                                if (access.isClientAdmin()) {
                                    next();
                                } else {
                                    error++;
                                }
                            } else {
                                if (access.hasAccessApplicationByFunctionality(f)) {
                                    if (access.hasAccess(f, appsId, action)) {
                                        if (profiles) {
                                            if (
                                                profiles.some(p => access.hasAccessByProfile(p, APPLICATION.FORECAST_ID)) ||
                                                profiles.some(p => access.hasAccessByProfile(p, APPLICATION.CATALOG_FORECAST_ID))
                                            ) {
                                                next();
                                            } else {
                                                error++;
                                            }
                                        } else {
                                            next();
                                        }
                                    } else {
                                        error++;
                                    }
                                } else {
                                    error++;
                                }
                            }
                        });
                        if (error === to.meta.functionality.length) {
                            next({
                                name: "error403"
                            });
                        }
                    } else {
                        next();
                    }
                    return true;
                });
            }
        } else {
            if (to.query.keep || to.name != "error404") {
                sessionStorage.setItem("urlKept", to.fullPath);
            }
            next({
                name: "Login"
            });
        }
    } else {
        next();
    }
});

// If brand/zone in query are different from current brand/zone:
//  1. remove the brand/zone query param
//  2. change to target brand/zone
//  3. reload the original url
//
//  example url: /foo/bar?brand=3&zone=2
function handleBrandAndZoneQueryParameters(to, from, next) {
    let brand = null;
    let brandId = cacheService.getCurrentBrandId();
    if (to.query.brand) {
        brandId = parseInt(to.query.brand);
    }
    let allBrands = brandService.getAll();
    if (allBrands.some(brand => brand.id === brandId)) {
        brand = allBrands.find(brand => brand.id === brandId);
    } else {
        console.error(
            `Brand with id ${brandId} was passed as query parameter but the user doesn't have access to this brand. Removing query parameters...`
        );
        removeQueryParameters(to, from, next);
        return;
    }
    let zoneId = null;
    if (to.query.zone) {
        zoneId = parseInt(to.query.zone);
    }
    // change to brand/zone if current brand/zone is not correct
    if (brandId !== cacheService.getCurrentBrandId() || zoneId !== cacheService.getCurrentZoneId()) {
        sessionStorage.setItem("targetUrl", to.path);
        // changing the brand will reload the page; no need to next()
        currentBrand.save(brand, zoneId, Vue.accessUser);
    }
}

function removeQueryParameters(to, from, next) {
    // this removes ALL query parameters by pushing to the original route by name
    // /foo/bar?brand=3&zone=2 becomes /foo/bar
    next({ name: to.name });
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js